import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/app.css";
import "./registerServiceWorker";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import i18n from "./i18n";
import filters from "./filters";
import AOS from "aos";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import TextEditor from "@/components/TextEditor.vue";
import InfiniteSlideBar from "vue-infinite-slide-bar";
import VueMeta from "vue-meta";
import ImageCropper from "@/components/ImageCropper.vue";

AOS.init();

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(CKEditor);
Vue.use(VueMeta);

Vue.component("InfiniteSlideBar", InfiniteSlideBar);
Vue.component("v-select", vSelect);
Vue.component("TextEditor", TextEditor);
Vue.component("ImageCropper", ImageCropper);

Vue.config.productionTip = false;

new Vue({
  filters,
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
